(function () {
  'use strict';

  // ---------------------------------------------------------------------
  // DATA SOURCE 1: Champs Land's OWN size-guide pages (real, single body
  // measurement per category - chest/bust/waist/height). Used for the
  // credibility footer on the result screen and for the "kids" flow
  // (which is height-only, same as Champs Land's own Kids Size Guide page).
  // ---------------------------------------------------------------------
  var OWN_DATA = {
    mens_tops: {
      label: 'Chest',
      sizes: [
        { size: 'XS', center: 88 }, { size: 'S', center: 94 }, { size: 'M', center: 100 },
        { size: 'L', center: 106 }, { size: 'XL', center: 112 }, { size: '2XL', center: 119 },
        { size: '3XL', center: 126 }, { size: '4XL', center: 133 }
      ]
    },
    womens_tops: {
      label: 'Bust',
      sizes: [
        { size: 'XS', center: 88 }, { size: 'S', center: 94 }, { size: 'M', center: 100 },
        { size: 'L', center: 106 }, { size: 'XL', center: 112 }, { size: '2XL', center: 119 },
        { size: '3XL', center: 126 }, { size: '4XL', center: 133 }
      ]
    },
    mens_pants: {
      label: 'Waist',
      sizes: [
        { size: 'S', lo: 71, hi: 76 }, { size: 'M', lo: 81, hi: 86 }, { size: 'L', lo: 91, hi: 96 },
        { size: 'XL', lo: 101, hi: 106 }, { size: '2XL', lo: 111, hi: 116 }, { size: '3XL', lo: 121, hi: 126 },
        { size: '4XL', lo: 131, hi: 136 }
      ]
    },
    womens_pants: {
      label: 'Waist',
      sizes: [
        { size: 'XXS', lo: 58, hi: 61 }, { size: 'XS', lo: 61, hi: 64 }, { size: 'S', lo: 66, hi: 69 },
        { size: 'M', lo: 72, hi: 75 }, { size: 'L', lo: 78, hi: 83 }, { size: 'XL', lo: 88, hi: 93 },
        { size: '2XL', lo: 98, hi: 103 }
      ]
    },
    underwear: {
      label: 'Waist',
      sizes: [
        { size: 'S', lo: 71, hi: 76 }, { size: 'M', lo: 81, hi: 86 }, { size: 'L', lo: 91, hi: 96 },
        { size: 'XL', lo: 101, hi: 106 }, { size: '2XL', lo: 111, hi: 116 }, { size: '3XL', lo: 121, hi: 126 },
        { size: '4XL', lo: 131, hi: 136 }
      ]
    },
    kids: {
      label: 'Height',
      sizes: [
        { size: '2–4 yrs', lo: 92, hi: 110 }, { size: '4–6 yrs', lo: 110, hi: 120 },
        { size: '6–8 yrs', lo: 120, hi: 130 }, { size: '8–10 yrs', lo: 130, hi: 140 },
        { size: '10–12 yrs', lo: 140, hi: 152 }, { size: '12–14 yrs', lo: 152, hi: 164 }
      ]
    }
  };

  // ---------------------------------------------------------------------
  // DATA SOURCE 2: height + weight to size, synthesized from published
  // competitor charts researched for this feature (men's/women's tops;
  // reused for pants/underwear per the same gender, since most brands use
  // one size ladder across garment types - documented limitation, see
  // claude/fit-finder-feature.md). Sources: Live and Breathe Active
  // (men's + women's size charts), Gymreapers/YoungLA shared matrix
  // (men's). Only 2-3 independent brands publish genuine height+weight
  // charts industry-wide (most activewear brands size by chest/waist
  // only) - treat this as a reasonable starting estimate, refined below
  // by the shape and fit-preference steps, not a precise measurement.
  // ---------------------------------------------------------------------
  var HW_DATA = {
    men: [
      { size: 'XS', hLo: 155, hHi: 168, wLo: 50, wHi: 62 },
      { size: 'S', hLo: 160, hHi: 175, wLo: 60, wHi: 70 },
      { size: 'M', hLo: 168, hHi: 183, wLo: 68, wHi: 80 },
      { size: 'L', hLo: 173, hHi: 190, wLo: 78, wHi: 92 },
      { size: 'XL', hLo: 178, hHi: 195, wLo: 88, wHi: 100 },
      { size: '2XL', hLo: 183, hHi: 200, wLo: 98, wHi: 112 },
      { size: '3XL', hLo: 185, hHi: 203, wLo: 110, wHi: 125 },
      { size: '4XL', hLo: 188, hHi: 205, wLo: 123, wHi: 140 }
    ],
    women: [
      { size: 'XS', hLo: 150, hHi: 163, wLo: 45, wHi: 55 },
      { size: 'S', hLo: 155, hHi: 168, wLo: 53, wHi: 62 },
      { size: 'M', hLo: 160, hHi: 173, wLo: 60, wHi: 70 },
      { size: 'L', hLo: 165, hHi: 178, wLo: 68, wHi: 80 },
      { size: 'XL', hLo: 170, hHi: 183, wLo: 78, wHi: 92 },
      { size: '2XL', hLo: 175, hHi: 188, wLo: 90, wHi: 105 },
      { size: '3XL', hLo: 178, hHi: 191, wLo: 103, wHi: 120 },
      { size: '4XL', hLo: 180, hHi: 193, wLo: 118, wHi: 135 }
    ]
  };

  var FIT_SCALE_LABELS = {
    1: 'runs small / compression', 2: 'fitted / slim', 3: 'true to size / regular',
    4: 'relaxed / loose', 5: 'oversized / baggy'
  };

  var SHAPE_SHIFT = { slimmer: -1, flatter: -1, narrower: -1, average: 0, broader: 1, rounder: 1, fuller: 1 };

  function cmToIn(cm) { return cm / 2.54; }
  function inToCm(inches) { return inches * 2.54; }
  function kgToLb(kg) { return kg * 2.20462; }
  function lbToKg(lb) { return lb / 2.20462; }

  function formatHeight(cm, unit) {
    if (unit === 'ftin') {
      var totalIn = Math.round(cmToIn(cm));
      var ft = Math.floor(totalIn / 12);
      var inch = totalIn % 12;
      return ft + "'" + inch + '"';
    }
    return Math.round(cm) + ' cm';
  }

  function formatWeight(kg, unit) {
    if (unit === 'lb') return Math.round(kgToLb(kg)) + ' lb';
    return Math.round(kg) + ' kg';
  }

  // ---- own-data (single dimension) matching, used only for kids ----
  function distanceToOwn(value, entry) {
    if (typeof entry.center === 'number') return Math.abs(value - entry.center);
    if (value < entry.lo) return entry.lo - value;
    if (value > entry.hi) return value - entry.hi;
    return 0;
  }
  function matchOwn(value, sizes) {
    var best = null, bestDist = Infinity;
    for (var i = 0; i < sizes.length; i++) {
      var d = distanceToOwn(value, sizes[i]);
      if (d < bestDist) { bestDist = d; best = sizes[i]; }
    }
    return { entry: best, distance: bestDist };
  }

  // ---- height+weight (2D) matching ----
  function matchHW(heightCm, weightKg, table) {
    var best = null, bestDist = Infinity;
    for (var i = 0; i < table.length; i++) {
      var e = table[i];
      var hOver = heightCm < e.hLo ? e.hLo - heightCm : heightCm > e.hHi ? heightCm - e.hHi : 0;
      var wOver = weightKg < e.wLo ? e.wLo - weightKg : weightKg > e.wHi ? weightKg - e.wHi : 0;
      // Weight is the stronger size signal for fitted/athletic apparel; height is a secondary
      // tiebreaker. This weighting mirrors how the two cleanest researched sources treat it.
      var d = wOver + hOver * 0.3;
      if (d < bestDist) { bestDist = d; best = e; }
    }
    return { entry: best, distance: bestDist };
  }

  function confidenceFor(distance, scale) {
    var pct = 100 - Math.round(distance * scale);
    return Math.max(60, Math.min(99, pct));
  }

  function shiftIndex(table, sizeLabel, steps) {
    if (!steps) return sizeLabel;
    var idx = -1;
    for (var i = 0; i < table.length; i++) { if (table[i].size === sizeLabel) { idx = i; break; } }
    if (idx === -1) return sizeLabel;
    var newIdx = Math.max(0, Math.min(table.length - 1, idx + steps));
    return table[newIdx].size;
  }

  function fitPreferenceShift(preference, productFitScale) {
    var scale = parseInt(productFitScale, 10);
    if (isNaN(scale)) scale = 3;
    if (preference === 'slim' && scale >= 4) return -1;
    if (preference === 'relaxed' && scale <= 2) return 1;
    return 0;
  }

  // Detects men/women for categories that don't already imply it (underwear).
  function detectGender(root) {
    var explicit = root.getAttribute('data-gender');
    if (explicit === 'men' || explicit === 'women') return explicit;
    return 'men';
  }

  function initFitFinder(root) {
    var category = root.getAttribute('data-category');
    var ownData = OWN_DATA[category];
    if (!ownData) return;

    var isKids = category === 'kids';
    var gender = detectGender(root);
    var hwTable = HW_DATA[gender];
    var productFitScale = root.getAttribute('data-product-fit-scale');
    var storageKey = 'champsland_fit_profile_' + category;

    var overlay = root.querySelector('[data-fit-finder-overlay]');
    var drawer = root.querySelector('[data-fit-finder-drawer]');
    var openBtn = root.querySelector('[data-fit-finder-open]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fit-finder-close]'));
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-fit-finder-step]'));
    var progressDots = Array.prototype.slice.call(root.querySelectorAll('[data-fit-finder-progress] span'));

    var state = {
      step: 1,
      heightCm: null,
      weightKg: null,
      heightUnit: 'cm',
      weightUnit: 'kg',
      chest: 'average',
      stomach: 'average',
      hips: 'average',
      preference: 'regular',
      started: false
    };

    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved && typeof saved.heightCm === 'number') {
        state.heightCm = saved.heightCm;
        state.weightKg = saved.weightKg || null;
        state.heightUnit = saved.heightUnit || 'cm';
        state.weightUnit = saved.weightUnit || 'kg';
        state.chest = saved.chest || 'average';
        state.stomach = saved.stomach || 'average';
        state.hips = saved.hips || 'average';
        state.preference = saved.preference || 'regular';
        state.started = true;
      }
    } catch (e) { /* localStorage unavailable - continue without a saved profile */ }

    function totalSteps() { return isKids ? 3 : 3; }

    function showStep(n) {
      state.step = n;
      steps.forEach(function (el) {
        el.hidden = parseInt(el.getAttribute('data-fit-finder-step'), 10) !== n;
      });
      progressDots.forEach(function (dot, i) { dot.classList.toggle('is-active', i < n); });
      if (n === totalSteps() + 1) renderResult();
    }

    function open() {
      overlay.hidden = false;
      drawer.hidden = false;
      document.body.classList.add('fit-finder-open');
      showStep(state.started ? totalSteps() + 1 : 1);
    }
    function close() {
      overlay.hidden = true;
      drawer.hidden = true;
      document.body.classList.remove('fit-finder-open');
    }
    if (openBtn) openBtn.addEventListener('click', open);
    closeButtons.forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);

    // Step 1: height (+ weight unless kids)
    var heightValueEl = root.querySelector('[data-fit-finder-height-value]');
    var weightValueEl = root.querySelector('[data-fit-finder-weight-value]');
    var weightBlock = root.querySelector('[data-fit-finder-weight-block]');
    if (isKids && weightBlock) weightBlock.hidden = true;

    function defaultHeightCm() { return gender === 'women' ? 165 : 175; }
    function defaultWeightCm() { return gender === 'women' ? 65 : 78; }
    function currentHeightCm() { return state.heightCm !== null ? state.heightCm : defaultHeightCm(); }
    function currentWeightKg() { return state.weightKg !== null ? state.weightKg : defaultWeightCm(); }

    function renderHeight() {
      if (heightValueEl) heightValueEl.textContent = formatHeight(currentHeightCm(), state.heightUnit === 'ftin' ? 'ftin' : 'cm');
      root.querySelectorAll('[data-fit-finder-height-unit]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-fit-finder-height-unit') === state.heightUnit);
      });
    }
    function renderWeight() {
      if (weightValueEl) weightValueEl.textContent = formatWeight(currentWeightKg(), state.weightUnit);
      root.querySelectorAll('[data-fit-finder-weight-unit]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-fit-finder-weight-unit') === state.weightUnit);
      });
    }

    root.querySelectorAll('[data-fit-finder-height-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () { state.heightUnit = btn.getAttribute('data-fit-finder-height-unit'); renderHeight(); });
    });
    root.querySelectorAll('[data-fit-finder-weight-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () { state.weightUnit = btn.getAttribute('data-fit-finder-weight-unit'); renderWeight(); });
    });

    var heightMinus = root.querySelector('[data-fit-finder-height-minus]');
    var heightPlus = root.querySelector('[data-fit-finder-height-plus]');
    var weightMinus = root.querySelector('[data-fit-finder-weight-minus]');
    var weightPlus = root.querySelector('[data-fit-finder-weight-plus]');

    if (heightMinus) heightMinus.addEventListener('click', function () {
      var delta = state.heightUnit === 'ftin' ? inToCm(1) : 1;
      state.heightCm = Math.max(100, currentHeightCm() - delta);
      renderHeight();
    });
    if (heightPlus) heightPlus.addEventListener('click', function () {
      var delta = state.heightUnit === 'ftin' ? inToCm(1) : 1;
      state.heightCm = Math.min(230, currentHeightCm() + delta);
      renderHeight();
    });
    if (weightMinus) weightMinus.addEventListener('click', function () {
      var delta = state.weightUnit === 'lb' ? lbToKg(1) : 1;
      state.weightKg = Math.max(30, currentWeightKg() - delta);
      renderWeight();
    });
    if (weightPlus) weightPlus.addEventListener('click', function () {
      var delta = state.weightUnit === 'lb' ? lbToKg(1) : 1;
      state.weightKg = Math.min(200, currentWeightKg() + delta);
      renderWeight();
    });

    renderHeight();
    renderWeight();

    root.querySelectorAll('[data-fit-finder-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.step === 1) {
          state.heightCm = currentHeightCm();
          state.weightKg = currentWeightKg();
          state.started = true;
        }
        if (isKids) { showStep(totalSteps() + 1); return; }
        showStep(Math.min(totalSteps() + 1, state.step + 1));
      });
    });
    root.querySelectorAll('[data-fit-finder-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(Math.max(1, state.step - 1)); });
    });

    // Step 2: shape (chest / stomach / hips - each a row of icon buttons)
    ['chest', 'stomach', 'hips'].forEach(function (part) {
      root.querySelectorAll('[data-fit-finder-' + part + ']').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[part] = btn.getAttribute('data-fit-finder-' + part);
          root.querySelectorAll('[data-fit-finder-' + part + ']').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    });

    // Step 3: fit preference
    root.querySelectorAll('[data-fit-finder-preference]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.preference = btn.getAttribute('data-fit-finder-preference');
        root.querySelectorAll('[data-fit-finder-preference]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    function combinedShapeShift() {
      var vals = [SHAPE_SHIFT[state.chest] || 0, SHAPE_SHIFT[state.stomach] || 0, SHAPE_SHIFT[state.hips] || 0];
      var avg = (vals[0] + vals[1] + vals[2]) / 3;
      return Math.round(avg);
    }

    function renderResult() {
      var resultSize = root.querySelector('[data-fit-finder-result-size]');
      var resultConfidence = root.querySelector('[data-fit-finder-result-confidence]');
      var resultNote = root.querySelector('[data-fit-finder-result-note]');
      var resultOwnData = root.querySelector('[data-fit-finder-result-owndata]');
      var resultDisclaimer = root.querySelector('[data-fit-finder-result-disclaimer]');

      var finalSizeLabel, confidence, noteText;

      if (isKids) {
        var matched = matchOwn(currentHeightCm(), ownData.sizes);
        finalSizeLabel = matched.entry.size;
        confidence = confidenceFor(matched.distance, 7);
        noteText = confidence >= 90
          ? 'A confident match for their height.'
          : "They're near the edge between two age sizes — if they're tall for their age, size up.";
      } else {
        var hwMatch = matchHW(currentHeightCm(), currentWeightKg(), hwTable);
        var baseLabel = hwMatch.entry.size;
        var shapeShift = combinedShapeShift();
        var prefShift = fitPreferenceShift(state.preference, productFitScale);
        finalSizeLabel = shiftIndex(hwTable, baseLabel, shapeShift);
        finalSizeLabel = shiftIndex(hwTable, finalSizeLabel, prefShift);
        confidence = confidenceFor(hwMatch.distance, 3);

        noteText = confidence >= 90
          ? 'A confident starting size from your height and weight.'
          : confidence >= 75
          ? "You're close to the center of this size."
          : "You're between two sizes on height/weight alone — your shape and fit answers below helped refine it.";

        var adjustedBy = [];
        if (shapeShift !== 0) adjustedBy.push('your shape (' + (shapeShift > 0 ? 'broader' : 'slimmer') + ' than average)');
        if (prefShift !== 0) adjustedBy.push('this product running ' + (FIT_SCALE_LABELS[productFitScale] || 'true to size') + ' while you wanted a ' + state.preference + ' fit');
        if (adjustedBy.length) {
          noteText += ' Adjusted from the height/weight baseline of ' + baseLabel + ' for ' + adjustedBy.join(' and ') + '.';
        }
      }

      if (resultSize) resultSize.textContent = finalSizeLabel;
      if (resultConfidence) resultConfidence.textContent = confidence + '% fit match';
      if (resultNote) resultNote.textContent = noteText;

      if (resultOwnData) {
        var ownEntry = null;
        for (var i = 0; i < ownData.sizes.length; i++) {
          if (ownData.sizes[i].size === finalSizeLabel) { ownEntry = ownData.sizes[i]; break; }
        }
        if (ownEntry && !isKids) {
          var val = typeof ownEntry.center === 'number' ? ownEntry.center : Math.round((ownEntry.lo + ownEntry.hi) / 2);
          resultOwnData.textContent = ownData.label + ' for size ' + finalSizeLabel + ' (Champs Land’s own chart): ~' + val + 'cm';
        } else {
          resultOwnData.textContent = '';
        }
      }
      if (resultDisclaimer) {
        resultDisclaimer.textContent = isKids
          ? 'Based on Champs Land’s own Kids Size Guide.'
          : 'Starting size estimated from published height/weight sizing data across the activewear category; refined by your shape and fit answers. Individual fit may vary by style.';
      }

      try {
        localStorage.setItem(storageKey, JSON.stringify({
          heightCm: state.heightCm, weightKg: state.weightKg, heightUnit: state.heightUnit, weightUnit: state.weightUnit,
          chest: state.chest, stomach: state.stomach, hips: state.hips, preference: state.preference
        }));
      } catch (e) { /* ignore storage errors */ }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-fit-finder]');
    for (var i = 0; i < roots.length; i++) initFitFinder(roots[i]);
  });
})();
